import module from 'module';

module.directive('stringToBoolean', function(){
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      ngModel.$parsers.push(function(value) {
        return '' + value;
      });
      ngModel.$formatters.push(function(value) {
        return String(value).toLowerCase() === "true";
      });
    }
  };
});
